class SwiperElement extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
  }

  connectedCallback() {
    const swiperEl = this.querySelector(".swiper");
    if (!swiperEl || typeof Swiper === "undefined") return;

    const effect = this.getAttribute("effect");

    const options = {
      slidesPerView: this.numberAttr("slides-per-view", 1),
      spaceBetween: this.numberAttr("space-between", 0),
      centeredSlides: this.hasAttribute("centered"),
      loop: this.hasAttribute("loop"),
      initialSlide: this.numberAttr("initial-slide", 0),
      slideToClickedSlide: this.hasAttribute("clicked-to-slide"),
      speed: this.numberAttr("speed", 300),
      effect: effect || "slide",
    };

    /* ---------------------------
       Coverflow Effect
    ---------------------------- */
    if (effect === "coverflow") {
      options.coverflowEffect = {
        rotate: this.numberAttr("coverflow-rotate", 50),
        stretch: this.numberAttr("coverflow-stretch", 0),
        depth: this.numberAttr("coverflow-depth", 100),
        scale: this.numberAttr("coverflow-scale", 1),
        modifier: this.numberAttr("coverflow-modifier", 1),
        slideShadows: this.boolAttr("coverflow-shadows", true),
      };
    }

    /* ---------------------------
       Navigation
    ---------------------------- */
    const next = this.getAttribute("next");
    const prev = this.getAttribute("prev");

    if (next && prev) {
      options.navigation = {
        nextEl: this.querySelector(next),
        prevEl: this.querySelector(prev),
      };
    }

    /* ---------------------------
       Pagination
    ---------------------------- */
    const pagination = this.getAttribute("pagination");

    if (pagination) {
      options.pagination = {
        el: this.querySelector(pagination),
        clickable: true,
      };
    }

    /* ---------------------------
       Breakpoints
    ---------------------------- */
    const breakpoints = this.getAttribute("breakpoints");

    if (breakpoints) {
      try {
        options.breakpoints = JSON.parse(breakpoints);
      } catch (e) {
        console.warn("Invalid Swiper breakpoints JSON", e);
      }
    }

    this.swiper = new Swiper(swiperEl, options);
  }

  disconnectedCallback() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }

  numberAttr(name, fallback) {
    const value = this.getAttribute(name);
    return value !== null ? Number(value) : fallback;
  }

  boolAttr(name, fallback) {
    const value = this.getAttribute(name);
    return value !== null ? value !== "false" : fallback;
  }
}

customElements.define("swiper-element", SwiperElement);
